import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import {PageWrapper} from 'components/PageWrapper';
import {InputText} from '../../../blocks/inputs/InputText';
import {FileInput} from '../../../blocks/inputs/FileInput';
import SelectFieldWrapper from '../../../blocks/SelectFieldWrapper';
import pdfIcon from 'images/pdfFile.svg';

@inject('sampleContentStore')
@observer
class SampleContentForm extends PureComponent {
  handleChange = e => {
    const {sampleContentStore} = this.props;

    if (e.target.name === 'file') {
      sampleContentStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      sampleContentStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  renderEmbeded = url => {
    return (
      <div
        dangerouslySetInnerHTML={{__html: url}}
        className='topic-video'
      />
    );
  };

  render() {
    const {sampleContentStore, submit} = this.props;
    const {sampleContent, errors} = sampleContentStore;
    const isNew = !sampleContent.id;
    const types = [
      {
        title: 'Video',
        value: 0,
      },
      {
        title: 'OSCE',
        value: 1,
      },
    ];

    return (
      <PageWrapper>
        <form className="simple-form" onSubmit={submit}>
          <h2>{isNew ? 'Add Sample Content' : 'Edit Sample Content'}</h2>
          <InputText
            label='Add a Title'
            placeholder='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={sampleContent.title}
            name='title'
            errorText={errors ? errors.title : ''}
          />
          <SelectFieldWrapper
            elements={types}
            placeholder="Type:"
            name='sample_type'
            value={sampleContent.sample_type}
            onChange={this.handleChange}
            errorText={errors ? errors.sample_type : ''}
            fullWidth={true}
          />
          {sampleContent.sample_type === 0 && (
            <InputText
              label='Add a Video URL'
              placeholder='Add a Video URL'
              fullWidth={true}
              onChange={this.handleChange}
              value={sampleContent.video_url}
              name='video_url'
              errorText={errors ? errors.video_url : ''}
            />
          )}
          {sampleContent.sample_type === 1 && (
            <FileInput
            label='Add a PDF'
            placeholder='Add a PDF'
            fullWidth={true}
            onChange={this.handleChange}
            value={sampleContent.file}
            name='file'
            type='file'
            accept='.pdf'
            errorText={errors ? errors.file : ''}
          />)}
          {(!!sampleContent.file_url && !(sampleContent.file && sampleContent.file.name)) && (
            <a
              href={`https://pharmacistexamprep.ie${sampleContent.file_url}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />PDF
            </a>
          )}
          {!!(sampleContent.file && sampleContent.file.name) && (
            <a
              href={`https://pharmacistexamprep.ie${sampleContent.file.name}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />{sampleContent.file.name}
            </a>
          )}
          <div className="row">
            <button className="btn-new-main" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to='/sample_content' className="btn-new-white margin-left-20">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
}

export default SampleContentForm;



// WEBPACK FOOTER //
// ./src/modules/admin/sampleContent/components/Form.js